import { Component, ChangeDetectionStrategy, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
class NgxFontAwesomeComponent {
    constructor() {
        this.classes = '';
    }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    /**
     * getClasses()
     * Function will return Options in class form
     * @return {?}
     */
    getClasses() {
        (this.size) ? this.classes += `fa-${this.size} ` : '';
        (this.rotate) ? this.classes += `fa-rotate-${this.rotate} ` : '';
        (this.flip) ? this.classes += `fa-flip-${this.flip} ` : '';
        (this.customClass) ? this.classes += `${this.customClass} ` : '';
        return this.classes;
    }
}
NgxFontAwesomeComponent.ɵfac = function NgxFontAwesomeComponent_Factory(t) { return new (t || NgxFontAwesomeComponent)(); };
NgxFontAwesomeComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NgxFontAwesomeComponent, selectors: [["ngx-fa"]], inputs: { name: "name", size: "size", animation: "animation", rotate: "rotate", flip: "flip", fixed: "fixed", border: "border", customClass: "customClass" }, decls: 1, vars: 10, consts: [["aria-hidden", "true", 3, "ngClass"]], template: function NgxFontAwesomeComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "i", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMapInterpolate1("fa fa-", ctx.name, "");
        ɵngcc0.ɵɵclassProp("fa-fw", ctx.fixed)("fa-border", ctx.border)("fa-spin", ctx.animation);
        ɵngcc0.ɵɵproperty("ngClass", ctx.getClasses());
    } }, directives: [ɵngcc1.NgClass], encapsulation: 2, changeDetection: 0 });
/** @nocollapse */
NgxFontAwesomeComponent.ctorParameters = () => [];
NgxFontAwesomeComponent.propDecorators = {
    name: [{ type: Input }],
    size: [{ type: Input }],
    animation: [{ type: Input }],
    rotate: [{ type: Input }],
    flip: [{ type: Input }],
    fixed: [{ type: Input }],
    border: [{ type: Input }],
    customClass: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxFontAwesomeComponent, [{
        type: Component,
        args: [{
                selector: 'ngx-fa',
                template: `
    <i class="fa fa-{{ name }}"
      [ngClass]="getClasses()"
      [class.fa-fw]="fixed"
      [class.fa-border]="border"
      [class.fa-spin]="animation"
      aria-hidden="true">
    </i>
  `,
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return []; }, { name: [{
            type: Input
        }], size: [{
            type: Input
        }], animation: [{
            type: Input
        }], rotate: [{
            type: Input
        }], flip: [{
            type: Input
        }], fixed: [{
            type: Input
        }], border: [{
            type: Input
        }], customClass: [{
            type: Input
        }] }); })();
if (false) {
    /** @type {?} */
    NgxFontAwesomeComponent.prototype.name;
    /** @type {?} */
    NgxFontAwesomeComponent.prototype.size;
    /** @type {?} */
    NgxFontAwesomeComponent.prototype.animation;
    /** @type {?} */
    NgxFontAwesomeComponent.prototype.rotate;
    /** @type {?} */
    NgxFontAwesomeComponent.prototype.flip;
    /** @type {?} */
    NgxFontAwesomeComponent.prototype.fixed;
    /** @type {?} */
    NgxFontAwesomeComponent.prototype.border;
    /** @type {?} */
    NgxFontAwesomeComponent.prototype.customClass;
    /** @type {?} */
    NgxFontAwesomeComponent.prototype.classes;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NgxFontAwesomeModule {
}
NgxFontAwesomeModule.ɵfac = function NgxFontAwesomeModule_Factory(t) { return new (t || NgxFontAwesomeModule)(); };
NgxFontAwesomeModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgxFontAwesomeModule });
NgxFontAwesomeModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxFontAwesomeModule, [{
        type: NgModule,
        args: [{
                declarations: [NgxFontAwesomeComponent],
                imports: [
                    CommonModule
                ],
                exports: [NgxFontAwesomeComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxFontAwesomeModule, { declarations: function () { return [NgxFontAwesomeComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [NgxFontAwesomeComponent]; } }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { NgxFontAwesomeModule, NgxFontAwesomeComponent as ɵa };

